import * as yup from 'yup';
import { DateTime } from 'luxon';
import { idElectronicCard, idPaperCard } from 'shell/components/shared/type-indentity-card';

export const validationSchemaRegistrationIdCard = yup.object().shape({
  identityCard: yup.object().shape({
    number: yup
      .string()
      .required('Campo obbligatorio')
      // 0 -> carta d'identità cartacea
      // 3 -> carta d'dentittà elettronica
      .when(['type', 'releaseDate'], {
        is: (type: string, releaseDate: Date | null) => {
          return (
            type === idElectronicCard &&
            releaseDate &&
            DateTime.fromJSDate(releaseDate).get('year') < 2016
          );
        },
        then: yup
          .string()
          .required('Campo obbligatorio')
          .matches(/^\d{7}[a-zA-z]{2}$/, {
            message:
              'Per le carte di identità elettroniche rilasciate prima del 2016 devono esserci 7 caratteri numerici e un suffisso di 2 caratteri alfabetici. (es. 0000000AA)',
          }),
      })
      .when(['type', 'releaseDate'], {
        is: (type: string, releaseDate: Date | null) => {
          return (
            type === idElectronicCard &&
            releaseDate &&
            DateTime.fromJSDate(releaseDate).get('year') >= 2016
          );
        },
        then: yup
          .string()
          .required('Campo obbligatorio')
          .matches(/^[a-zA-z]{2}\d{5}[a-zA-z]{2}$/, {
            message:
              'Per le carte di identità elettroniche deve esserci un prefisso di 2 caratteri alfabetici, 5 caratteri numerici e un suffisso di 2 caratteri alfabetici. (es. AA00000AA)',
          }),
      })
      .when('type', {
        is: idPaperCard,
        then: yup
          .string()
          .required('Campo obbligatorio')
          .matches(/^[a-zA-z]{2}\d{7}$/, {
            message:
              'Numero carta di identità invalido, deve essere in uno di questi formati: AB0000198, CA00001AA o 1111101AB',
          }),
      }),
    type: yup.string().required('Campo obbligatorio'),
    expatriationBan: yup.boolean().required('Campo obbligatorio'),
    releaseDate: yup
      .date()
      .nullable()
      .required('Campo obbligatorio')
      .max(
        DateTime.local().endOf('day'),
        'La data di rilascio non può essere successiva alla data odierna'
      )
      .typeError('Data non valida'),
    expirationDate: yup
      .date()
      .nullable()
      .required('Campo obbligatorio')
      .min(
        yup.ref('releaseDate'),
        'La data di scadenza deve essere successiva alla data di rilascio'
      )
      .typeError('Data non valida'),
    cancellationDate: yup.date().nullable().typeError('Data non valida'),
    municipality: yup
      .object()
      .shape({
        description: yup.string(),
        province: yup.string(),
      })
      .nullable()
      .when('isConsulateRelease', {
        is: false,
        then: yup
          .object()
          .shape({
            description: yup.string().nullable().required('Campo obbligatorio'),
            province: yup.string().nullable().required('Campo obbligatorio'),
          })
          .nullable()
          .required('Campo'),
      }),
    province: yup.string(),
    // location: yup.string().when('isConsulateRelease', {
    //   is: false,
    //   then: yup.string().nullable().required('Campo obbligatorio'),
    // }),
    consulateCode: yup.string().when('isConsulateRelease', {
      is: true,
      then: yup.string().nullable().required('Campo obbligatorio'),
    }),
    isConsulateRelease: yup.boolean().required('Campo obbligatorio'),
    // toAccount: yup.boolean().required('Campo obbligatorio'),
    releaseMode: yup.string().required('Campo obbligatorio'),
    // typePayment: yup.string().required('Campo obbligatorio'),
  }),
});
